import { Expose, Transform } from "class-transformer";
import { Mapper } from "../../../../../lib/utils/mapper";
import type { SubscriptionKind } from "../../enums/subscription-kind.enum";
import type { ISubscriptionFrequenciesResponseData } from "../cms-subscription-with-pricing-remote/cms-subscription-with-pricing-remote.dto.interface";
import type {
  ICmsSubscriptionWithPricingDto,
  ISubscriptionFrequencyDto,
} from "./cms-subscription-with-pricing.dto.interface";

export class CmsSubscriptionWithPricingDto implements ICmsSubscriptionWithPricingDto {
  @Expose()
  externalProviderCode!: string;

  @Expose()
  order!: number;

  @Expose()
  kind!: SubscriptionKind;

  @Expose()
  pricingPageDescription!: string;

  @Expose()
  hasAI!: boolean;

  @Expose()
  @Transform(({ value }) => transformSubscriptionFrequencies(value), { toClassOnly: true })
  subscription_frequencies!: SubscriptionFrequencyDto[];
}

export class SubscriptionFrequencyDto implements ISubscriptionFrequencyDto {
  @Expose()
  pricing!: number;
  @Expose()
  code!: string;
}

export function transformSubscriptionFrequencies(
  value: ISubscriptionFrequenciesResponseData
): SubscriptionFrequencyDto[] | undefined {
  if (!value?.data) {
    return;
  }

  return value.data.map(function mapToDto({ attributes }) {
    const subscriptionFrequencyDto = Mapper.mapData(SubscriptionFrequencyDto, attributes);
    return subscriptionFrequencyDto;
  });
}
